<!--  -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" :content="title">
    </el-page-header>
    <div class="mMain">
      <div class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-s-promotion" @click="onFenPei"
            >分配</el-button
          >
          <div
            style="width: 24.0rem; margin-left: 3.0rem; display: inline-flex"
            @click.stop="onSelectPerson"
          >
            <el-input
              clearable
              v-model="person.name"
              placeholder="选择分配成员"
              suffix-icon="el-icon-arrow-down"
              @click.stop
            >
            </el-input>
          </div>
        </div>
        <div class="nav-r">
          <el-input
            clearable
            style="width: 22.0rem; margin: 0 2.0rem 0 .0rem"
            v-model="search"
            prefix-icon="el-icon-search"
            placeholder="请搜索客户"
            @change="onSearch"
          >
          </el-input>
          <el-button slot="append" type="primary" @click="onSearch()"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="container">
        <el-table
          ref="multipleTable"
          
          :data="tableData"
          tooltip-effect="dark"
          style="margin-top: 2.0rem"
          border
          @selection-change="onSelection"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="avatar"
            label="客户头像	"
            width="120"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 3.2rem; height: 3.2rem"
                :src="scope.row.avatar"
                :preview-src-list="[scope.row.avatar]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="客户姓名"
            min-width="120"
            header-align="center"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="120"
            header-align="center"
            show-overflow-tooltip
            align="center"
          ></el-table-column>
          <el-table-column
            prop="gender_name"
            label="性别"
            width="60"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type_name"
            label="来源"
            min-width="120"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getContactUsers"
        />
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "departureInheritanceDetail",
  components: {
    Pagination,
    rightPeople
  },
  data() {
    return {
      search: "",
      tableData: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      userid: "",
      title: "",
      person: {
        name: "",
        id: "",
      },
      module: "",
      checkbox: false
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.title = `${this.$route.query.name}-${this.$route.query.department_name}`;
    this.getContactUsers();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.person = person;
    },
    getContactUsers() {
      this.axios
        .post(
          "/crm/Dimission/getContactUsers",
          qs.stringify({
            phone: this.tooken.phone,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: this.$route.query.userid,
            name: this.search,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          const data = res.data;
          if (data.code == 1) {
            this.tableData = data.data.data;
            this.total = data.count;
          }
        })
        .catch(function (err) {});
    },
    onSelection(val) {
      this.multipleSelection = val;
    },
    onSearch() {
      this.getContactUsers();
    },
    onFenPei() {
      if (!this.person.userid) {
        this.$message("请选择要分配的成员");
        return;
      }
      if (!this.multipleSelection.length) {
        this.$message("请选择客户");
        return;
      }

      this.$confirm(`您确定要分配给${this.person.name}吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.onDistribute();
        })
        .catch(() => {});
    },
    async onDistribute() {
      const external_userid = this.multipleSelection.map((i) => {
        return i.external_userid;
      });

      const { data: res } = await this.axios({
        url: "/crm/Dimission/transferCustomer",
        method: "POST",
        data: qs.stringify({
          phone: this.tooken.phone,
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          handover_userid: this.$route.query.userid,
          takeover_userid: this.person.userid,
          external_userid: external_userid.toString(),
        }),
      });
      this.$message({
        message: res.msg,
        type: res.code == 1 ? "success" : "error",
      });
      this.getContactUsers();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
  },
};
</script>
<style scoped>
</style>